import { ModalService } from "@whatslly/ui-components/modals";
export const userManagementModals = new ModalService();
